export default __webpack_public_path__ + "static/media/gallery-33.512e72c6.jpg";